// ハイリスク疑い報告APIは counselor / operator / high_risk / developer のみ許可される。
// 許可されないロールでGET /newを呼ぶと403になり、共通インターセプタが画面遷移させるため、
// フロント側でもAPI呼び出し前に同じ条件で判定する。
const ALLOWED_CAPABILITIES = ["counselor:access", "operator:access", "high_risk:access", "developer:access"];

export const canUseHighRiskReport = (capabilities: readonly string[] | null | undefined): boolean =>
  ALLOWED_CAPABILITIES.some((capability) => (capabilities ?? []).includes(capability));